import { Announcement, Subject } from "../../lib/airtables/models";
import {
  SET_APP_USERINFO,
  SET_TOTAL_SUBJECTS,
  SET_ANNOUNCEMENTS,
  SET_ANNOUNCEMENTS_UNREAD,
  SET_MESSAGES_UNREAD,
} from "./types";

interface StatePros {
  userInfo: any;
  totalSubjects: Subject[];
  announcements: Announcement[];
  hasUnreadAnnouncements: boolean;
  hasUnreadMessages: boolean;
}

const initialState: StatePros = {
  userInfo: null,
  totalSubjects: [],
  announcements: [],
  hasUnreadAnnouncements: false,
  hasUnreadMessages: false,
}

const appReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_APP_USERINFO:
      return {
        ...state,
        userInfo: action.payload
      }
    case SET_TOTAL_SUBJECTS:
      return {
        ...state,
        totalSubjects: action.payload
      }
    case SET_ANNOUNCEMENTS:
      return {
        ...state,
        announcements: action.payload
      }
    case SET_ANNOUNCEMENTS_UNREAD:
      return {
        ...state,
        hasUnreadAnnouncements: action.payload
      }
    case SET_MESSAGES_UNREAD:
      return {
        ...state,
        hasUnreadMessages: action.payload
      }

    default:
      return state;
  }
}

export default appReducer;
